/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const thirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    CannotSpecify: 'CannotSpecify',
} as const;

export type ThirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnumKey =
    (typeof thirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnum)[keyof typeof thirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnum];

export type ThirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOption =
    ThirdPartyEnumsWasConfidentialOrSensitiveDataInvolvedOptionEnumKey;
